// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAFPqSsLh9gpMSiOPZwhyfvURqzl0WSYtY",
  authDomain: "renown-backend-assignment.firebaseapp.com",
  projectId: "renown-backend-assignment",
  storageBucket: "renown-backend-assignment.appspot.com",
  messagingSenderId: "196187995841",
  appId: "1:196187995841:web:29dbf8f39228fff7c2de40",
  measurementId: "G-6KSR1NBZ8D",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

// Export the initialized services
export { app, analytics, auth, firestore, storage };
